export const saLimitedReleasesListConstants = {
  SA_LIMITED_RELEASES_LIST_LOADING: "SA_LIMITED_RELEASES_LIST_LOADING",
  SA_LIMITED_RELEASES_LIST_SUCCESS: "SA_LIMITED_RELEASES_LIST_SUCCESS",
  SA_LIMITED_RELEASES_LIST_FAILURE: "SA_LIMITED_RELEASES_LIST_FAILURE",
};
